import { objectConfig } from '../../actions/actions';
import { createSlice } from '@reduxjs/toolkit';
import { FAILURE, PENDING, REQUIRED, SUCCESS } from './const.fetchStates';

/*
export
const accessors = {
	get
}
*/

export const assetsSlice = createSlice({
	name: 'assets',
	initialState: [],
	reducers: {
		fetchRequest(state, action) {
			const {
				payload,
				meta,
			} = action;
			const asset = state.find((asset) => asset.url === payload.url);
			if (!asset) {
				return state.concat({
					objectId: meta.objectId,
					// name: payload.name || '__no_name__',
					url: payload.url,
					type: payload.type || '__no_type__',
					fetch: REQUIRED,
				});
			}
		},
		fetchPending(state, action) {
			const {
				payload,
			} = action;
			return state.map((asset) => {
				if (payload.includes(asset.url)) {
					return {
						...asset,
						fetch: PENDING,
					};
				} else {
					return asset;
				}
			});
		},
		fetchSuccess(state, action) {
			const {
				payload: {
					data,
					url,
				},
			} = action;
			const indexOf = state.findIndex((asset) => asset.url === url);
			if (indexOf >= 0) { // TODO: test and clarify: is it required, is it work ass expected in immer context, does immer cost it?
				state[indexOf].data = data;
				state[indexOf].fetch = SUCCESS;
			}
		},
		fetchFailure(state, action) {
			const {
				payload: {
					error,
					url,
				},
			} = action;
			const indexOf = state.findIndex((asset) => asset.url === url);
			state[indexOf].error = error;
			state[indexOf].fetch = FAILURE;
		},
	},
	extraReducers: {
		[objectConfig.fulfilled](state, action) {
			const {
        payload: {
          emoji
        },
        meta: {
          arg
        }
			} = action;

      const objectIcons = emoji?.icons ?? [];

			return objectIcons.reduce((state, { name, url }) => {
				const asset = state.find((asset) => asset.url === url);
				if (!asset) {
					return state.concat({
						objectId: arg.object_id,
						name,
						url,
						type: 'emoji',
						fetch: REQUIRED,
					});
				}
				return state;
			}, state);
		},
	},
});
